import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { LoginService } from 'src/app/core/services/login.service';
import { LogoutService } from 'src/app//core/services/logout.service';

import { LoginData } from 'src/app/core/models/login-data';
import { FollowersComponent } from 'src/app/modules/feeds/pages/followers/followers.component';
import { FollowingComponent } from 'src/app/modules/feeds/pages/following/following.component';
import { ProfileService } from '../../services/profile.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DirDetailsService } from 'src/app/modules/directory/services/dir-details.service';
import { map, switchMap } from 'rxjs/operators';
import { GetNotificationsService } from 'src/app/modules/home/services/get-notifications.service';
import { UserNotification } from 'src/app/modules/home/models/notification';
import { of, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { BasicInfoTabService } from '../../../dashboard/modules/my-directory/services/basic-info-tab.service';
import { NextTabService } from 'src/app/modules/sign-up/services/next-tab.service';
import { SubscriptionPlansService } from 'src/app/modules/home/services/subscription-plans.service';
import { IncomProfComponent } from 'src/app/modules/sign-up/components/incom-prof/incom-prof.component';
import { LoginComponent } from 'src/app/modules/home/components/login/login.component';
import { SlsService } from 'src/app/core/services/sls.service';
import { FeedService } from 'src/app/modules/feeds/services/feed.service';
import { UserType } from 'src/app/core/models/permissions.model';
import { PermissionService } from 'src/app/shared/modules/services/permission.service';
import { BannersInfoTabService } from 'src/app/modules/dashboard/modules/banners/services/banners-info-tab-service';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { PermissionDeniedModalComponent } from 'src/app/modules/home/components/permission-modal/permission-denied-modal.component';

import { MenuItem } from './menu-item.interface'; // adjust path as needed

import { PROFESSIONAL_MENU_ITEMS } from './professional-menu-items';
import { SUPPLIER_MENU_ITEMS } from './supplier-menu-items';
import { PRACTICE_MENU_ITEMS } from './practice-menu-items';
import { tr } from 'date-fns/locale';
import { SignupPlanPaymentsComponent } from 'src/app/modules/sign-up/components/signup-plan-payments/signup-plan-payments.component';
import { PaymentModalService } from 'src/app/core/services/payment-modal.service';
import { CommunityMember } from '../join-request/join-request.component';


@Component({
  selector: 'app-profile-listing',
  templateUrl: './profile-listing.component.html',
  styleUrls: ['./profile-listing.component.scss']
})
export class ProfileListingComponent implements OnInit, OnDestroy {
  menuItems: MenuItem[] = PROFESSIONAL_MENU_ITEMS;
  supplierMenuItems: MenuItem[] = SUPPLIER_MENU_ITEMS;
  practiceMenuItems: MenuItem[] = PRACTICE_MENU_ITEMS;
  filteredMenuItems: MenuItem[] = [];
  dropdownStates: { [key: string]: boolean } = {};
  joinedCommunities: CommunityMember[] = [];
  business_name: string;
  community_status: string;
  community_id: string;
  communitySupplierData:any


  @ViewChildren('leftNavSlide') LeftNavBNSlideRefs!: QueryList<ElementRef>;
  leftNavBNObservers: IntersectionObserver[] = [];
  leftNavViewedBNIds: Set<number> = new Set();


  isDirectoryActive: boolean = false;
  customCollapsedHeight = "45px";
  loginDetails: any;
  customExpandedHeight = "45px";
  userProfileData: any;
  sellproducts: any;
  secondhand: any;
  count: any;
  followingIds = [];
  followersIds = [];
  isLoggedIn: boolean = false;
  loginData: LoginData;
  notificationList: UserNotification[];
  notificationsCount: number;
  jobprofile: any = 'jobprofile';
  userDetails: any;
  directory: any;
  isSubMenuOpen: boolean = false;
  isJobcornermenu: boolean;
  isCommunitymenu: boolean;
  isJobcornermenuProf: boolean;
  isJobsDropdownOpen: boolean;
  followercount: unknown;
  countOfFollowing: any;
  approvalStatusSubscription: Subscription
  countOfFollowers: any;
  isTalentmenu: boolean;
  isJObseekmenu: boolean;
  isSupportmenu: boolean;
  isBannerMenu: boolean;
  isCatalogueMenu: boolean = false;
  isSuppliesMenu: boolean = false;
  isDirectoryMenu: boolean = false;
  isMiscMenu: boolean = false;
  isSupportMenu: boolean = false;
  isUsedSuppliesMenu: boolean = false;
  isLearningHubMenu: boolean = false;
  subPlanDetails: any;
  userPrice: string;
  priceEx: string;

  constructor(
    public router: Router,
    private loginService: LoginService,
    private logoutService: LogoutService,
    private profileService: ProfileService,
    private _dialog: MatDialog,
    private getNotificationsService: GetNotificationsService,
    private dirService: DirDetailsService,
    private basicInfoTabService: BasicInfoTabService,
    private nextTabService: NextTabService,
    private subscriptionPlansService: SubscriptionPlansService,
    private sls: SlsService,
    private feedService: FeedService,
    private bannersInfoTabService: BannersInfoTabService,
    private paymentModalService: PaymentModalService
    //private _dialogRef: MatDialogRef<LoginComponent>,
  ) {

  }

  // Banner Advertisement
  ngAfterViewInit() {
    this.rightNavBannerSlides();
    this.LeftNavBNSlideRefs.changes.subscribe(() => {
      this.rightNavBannerSlides();
    });

  }

  ngOnInit(): void {
    this.toggleSubMenu(false)
    this.loginDetails = this.loginService.getLoginDataDirectory();
      this.loadCommunityData();
    // Run when the component initializes
    this.updateActiveState();
    this.initializeComponent();
    this.approvalStatusSubscription = this.feedService.approvalStatus$.subscribe(status => {
      if (status) {
        this.fetchUserCounts();
      }
    });

    // Listen for route changes
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateActiveState();
      }
    });


    this._dialog.closeAll();
    //this.popupClose();
    //alert('Hello I am in Profile listing page .!');
    this.sellproducts = this.loginDetails.sell_products
    this.secondhand = this.loginDetails.second_hand

    this.dirService.getUsersCount(this.loginDetails.id).subscribe(data => {
      this.count = data
    });


    this.loginService.isLoggedInSubject.pipe(map((status: boolean) => {
      return status ? this.loginService.getLoginDataDirectory() : null
    })).subscribe(data => {
      this.loginData = data;


      const modulePermissions = data?.subscription_permissions?.modules || [];
      const showAll = !Array.isArray(modulePermissions) || modulePermissions.length === 0;

      const permissionSet = new Set(
        modulePermissions
          .filter(m => m.permission === true)
          .map(m => m.name)
      );
      this.filteredMenuItems = this.filterMenuItems(this.supplierMenuItems, permissionSet, showAll);

    });
    this.loginService.isLoggedInSubject.pipe(switchMap((status: boolean) => {
      this.isLoggedIn = status;
      return this.isLoggedIn ? this.getNotificationsService.getNotifications() : of([])
    })).subscribe(({ notifications, notifications_aggregate }) => {
      this.notificationList = notifications ?? [];
      this.notificationsCount = notifications_aggregate ? notifications_aggregate.aggregate.count : 0;
    });


    // if (this.loginDetails.type == "SUPPLIER") {
    //   this.basicInfoTabService.userSupDirectory(this.loginDetails.id).subscribe(data => {
    //     this.directory = data[0];

    //     this.loginDetails = this.sls.get('loginData');
        

    //     if (data['length'] == 0 && this.loginDetails?.profile_completed === true) {

    //       this._dialog.open(IncomProfComponent, {
    //         width: '30%',
    //         panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    //         disableClose: true,
    //         data: this.loginDetails,
    //       });
    //     }

    //     if (
    //       !this.loginDetails?.directory_category_id &&
    //       this.loginDetails?.profile_completed === false
    //     ) {
    //       this._dialog.open(IncomProfComponent, {
    //         width: '30%',
    //         panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    //         disableClose: true,
    //         data: this.loginDetails,
    //       });

    //       // this.router.navigate(['/profile/directory/add']);
    //     }

    //   });

    // }

    // if (this.loginDetails.type == "PRACTICE") {
    //   //this.updateOnMap();
    //   this.basicInfoTabService.userPracDirectory(this.loginDetails.id).subscribe(data => {
    //     this.directory = data[0];

    //    this.loginDetails = this.sls.get('loginData');
       
    //     if (data['length'] == 0 && this.loginDetails?.profile_completed === true) {

    //       this._dialog.open(IncomProfComponent, {
    //         width: '30%',
    //         panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    //         disableClose: true,
    //         data: this.loginDetails,
    //       });

    //     }

    //     if (
    //       !this.loginDetails?.directory_category_id &&
    //       this.loginDetails?.profile_completed === false
    //     ) {
    //       this._dialog.open(IncomProfComponent, {
    //         width: '30%',
    //         panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    //         disableClose: true,
    //         data: this.loginDetails,
    //       });

    //       // this.router.navigate(['/profile/directory/add']);
    //     }
    //   });
    // }


    // if (this.loginDetails?.type == "PROFESSIONAL") {
    //   this.basicInfoTabService.userProfDirectory(this.loginDetails.id).subscribe(data => {
    //     this.directory = data[0];

    //    this.loginDetails = this.sls.get('loginData');

    //     if (data['length'] == 0 && this.loginDetails?.profile_completed === true) {
    //         console.log('98989089898989')

    //       this._dialog.open(IncomProfComponent, {
    //         width: '30%',
    //         panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    //         disableClose: true,
    //         data: this.loginDetails,
    //       });

    //     }

    //     if (
    //       !this.loginDetails?.directory_category_id &&
    //       this.loginDetails?.profile_completed === false
    //     ) {
    //         console.log('9890890')

    //       this._dialog.open(IncomProfComponent, {
    //         width: '30%',
    //         panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    //         disableClose: true,
    //         data: this.loginDetails,
    //       });

    //       // this.router.navigate(['/profile/directory/add']);
    //     }
    //   });
    // }

    if(this.loginDetails.type == "PRACTICE"){
    
      this.profileService.getUserProfilePracice(this.loginDetails.id).subscribe(data=>{
        this.userProfileData = data
        this.filteredMenuItems = this.practiceMenuItems;
        // this.loadPracticeCommunities();
        this.loadProfessionalOrPracticeCommunities();
        })

      }

    if(this.loginDetails.type == "PROFESSIONAL"){


      this.profileService.getUserProfileProfessional(this.loginDetails.id).subscribe(data=>{
        this.userProfileData = data;
        this.filteredMenuItems = this.menuItems;
        this.loadProfessionalOrPracticeCommunities();
      })

    }

      if(this.loginDetails.type === "SUPPLIER"){

        this.profileService.getUserProfileSuplier(this.loginDetails.id).subscribe(data=>{
          this.userProfileData = data
          // this.userForm.patchValue({
          //   email:this.userProfileData.email,
          //   phone:this.userProfileData.phone

          // })
        })

      }


    

    this.getFilteredBanners();
    this.getBannersCategory()

  }

  loadCommunityData() {
    const supplierId = this.loginDetails.id;
    const type = this.loginDetails.type;
    if (type === 'SUPPLIER') {
    this.profileService.getCommunitySupplier(supplierId).subscribe((data: any) => {
      this.communitySupplierData = data[0];
      this.filteredMenuItems = this.supplierMenuItems;

      // Check community membership
      if (
        this.communitySupplierData &&
        this.communitySupplierData.community_status === 'YES' &&
        this.communitySupplierData.community_id
      ) {
        this.addCommunityMenuItems(
          this.communitySupplierData.community_id,
          this.communitySupplierData.business_name
        );
      }
    });
  }
  }

 
  addCommunityMenuItems(communityId: string, communityName: string) {
    const communityActionKey = `toggleCommunityMenu_${communityId}`;
    const newsFeedActionKey = `toggleNewsFeedMenu`;

    //  Prevent duplicates — check if the community already exists
    const alreadyExists = this.filteredMenuItems.some(
      item => item.action === communityActionKey || item.label === `${communityName} Community`
    );
    if (alreadyExists) return; // stop duplicate insertion

    //  Create community-specific menu items
    const communityMenuItems: MenuItem[] = [
      {
        label: `${communityName} Community`,
        icon: 'groups',
        action: communityActionKey,
        children: [
          { label: 'Join Request', route: '/profile/join-request', class: 'noIconMenu' },
          { label: 'Partnership Request', route: '/profile/partnership-request', class: 'noIconMenu' },
          { label: 'Membership Registration', route: `/profile/membership-registration/${communityId}`, class: 'noIconMenu' },
          { label: 'Partnership Registration', route: `/profile/partnership-registration/${communityId}`, class: 'noIconMenu' },
          { label: 'News Feed Categories', route: `/profile/list-newsfeeds-catagory/${communityId}`, class: 'noIconMenu' },
        ]
      }
    ];

    //  Update News Feed section (ensure only one child set)
    const newsFeedIndex = this.filteredMenuItems.findIndex(item => item.label === 'News Feeds');
    if (newsFeedIndex !== -1) {
      const newsFeedItem = this.filteredMenuItems[newsFeedIndex];
      this.filteredMenuItems[newsFeedIndex] = {
        ...newsFeedItem,
        action: newsFeedActionKey,
        children: [
          {
            label: 'News Feed',
            route: '/profile/my-dashboard',
            class: 'noIconMenu',
            requiredPermission: 'news_feed_modules_permission'
          },
          {
            label: `${communityName} Community`,
            route: `/profile/community-feed/${communityId}`,
            class: 'noIconMenu'
          }
        ]
      };
    }

    //  Insert community dropdown before News Feeds (only once)
    const insertIndex = newsFeedIndex !== -1 ? newsFeedIndex : 0;
    this.filteredMenuItems.splice(insertIndex, 0, ...communityMenuItems);
  }




  ngOnDestroy(): void {
    if (this.approvalStatusSubscription) {
      this.approvalStatusSubscription.unsubscribe();
    }
  }

  initializeComponent(): void {
    // this.loginDetails = this.loginService.getLoginDataDirectory();
    this._dialog.closeAll();
    this.sellproducts = this.loginDetails.sell_products;
    this.secondhand = this.loginDetails.second_hand;
    this.fetchUserCounts();
    this.fetchFollowersDetails();
    this.subscribeToLoginStatus();
    this.subscribeToNotifications();
    this.handleUserTypeSpecificData();
  }

  fetchUserCounts(): void {
    const response = this.dirService.getUsersCount(this.loginDetails.id).subscribe((data: any) => {
      this.countOfFollowing = data.to_whome_i_am_following.length
      this.countOfFollowers = data.who_is_following.length
    });
  }
  fetchFollowersDetails(): void {
    this.dirService.getUsersDetailsFollowers(this.loginDetails.id).subscribe((data) => {
      this.followercount = data;
    });
  }
  subscribeToLoginStatus(): void {
    this.loginService.isLoggedInSubject.pipe(
      map((status: boolean) => (status ? this.loginService.getLoginData() : null))
    ).subscribe((data) => {
      this.loginData = data;
    });
  }
  subscribeToNotifications(): void {
    this.loginService.isLoggedInSubject.pipe(
      switchMap((status: boolean) => {
        this.isLoggedIn = status;
        return this.isLoggedIn ? this.getNotificationsService.getNotifications() : of([]);
      })
    ).subscribe(({ notifications, notifications_aggregate }) => {
      this.notificationList = notifications ?? [];
      this.notificationsCount = notifications_aggregate ? notifications_aggregate.aggregate.count : 0;
    });
  }
  handleUserTypeSpecificData(): void {
    if (this.loginDetails.type === "SUPPLIER") {
      this.fetchSupplierData();
    } else if (this.loginDetails.type === "PRACTICE") {
      // this.fetchPracticeData();
    } else if (this.loginDetails.type === "PROFESSIONAL") {
      // this.fetchProfessionalData();
    }
  }

  fetchSupplierData(): void {
    this.basicInfoTabService.userSupDirectory(this.loginDetails.id).subscribe((data) => {
      this.directory = data[0];
    });
    this.nextTabService.getUserSupplier(this.loginDetails.id).subscribe((data) => {
      this.userDetails = data;
      this.subscriptionPlansService.getSubPlanById(this.userDetails.id).subscribe();
      if (this.userDetails.user_subscriptions.length === 0) {
        // this._dialog.open(IncomProfComponent, {
        //   width: '30%',
        //   panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
        //   disableClose: true,
        //   data: this.userDetails,
        // });
      }
    });
  }

  // popupClose() {
  //   document.getElementsByClassName("animate__animated")[0].classList.remove("animate__slideInDown")
  //   document.getElementsByClassName("animate__animated")[0].classList.add("animate__slideOutUp");
  //   setTimeout(() => { this._dialogRef.close(); }, 1000);
  // }

  toggleSubMenu(shouldNavigate = false) {
    this.isSubMenuOpen = !this.isSubMenuOpen;

    this.isJobcornermenu = false;
    this.isCommunitymenu = false;
    this.isCatalogueMenu = false;
    this.isSuppliesMenu = false;
    this.isDirectoryMenu = false;
    this.isMiscMenu = false;
    if (shouldNavigate && this.isSubMenuOpen) {
      this.router.navigate(['/profile/my-dashboard']);
    }
  }



  toggleJobcornerMenu() {
    this.isJobcornermenu = !this.isJobcornermenu;
    this.isSubMenuOpen = false;
    if (this.isJobcornermenu) {
      this.router.navigate(['/profile/job-listing']);
    }
    this.isBannerMenu = false;
  }
  toggleTalentcornerMenu() {
    this.isTalentmenu = !this.isTalentmenu;
    if (this.isTalentmenu) {
      this.router.navigate(['/profile/talent-listing']);
    }
  }
  toggleJobseekMenu() {
    this.isJObseekmenu = !this.isJObseekmenu;
    if (this.isJObseekmenu) {
      this.router.navigate(['/profile/job-listing']);
    }
    this.isSupportmenu = false;
    this.isJobcornermenu = false;
  }
  toggleSupprtMenu() {
    this.isSupportmenu = !this.isSupportmenu;
    if (this.isSupportmenu) {
      this.router.navigate(['/profile/support-management']);
    }
    this.isJObseekmenu = false;
    this.isJobcornermenu = false;

  }
  toggleCommunityMenu() {
    this.isCommunitymenu = !this.isCommunitymenu;
    if (this.isCommunitymenu) {
      this.router.navigate(['/profile/join-request']);
    }
    this.isJobcornermenu = false;
    this.isSupportmenu = false;
    this.isJObseekmenu = false;
  }



  toggleBannersMenu() {
    this.isCatalogueMenu = false;
    this.isBannerMenu = !this.isBannerMenu;
    if (this.isBannerMenu) {
      this.router.navigate(['/profile/banners/banner-list']);
    }
    // this.isJobcornermenu = false;
  }
  logout() {
    this.logoutService.logout();
    this.loginService.setLoggedInSubject();
    this.router.navigate(['/index']);
  }

  followIngPopup() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/profile/my-dashboard']);
      this.sls.set('followingList', true);
    });
  }
  followersPopup() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/profile/my-dashboard']);
      this.sls.set('followerList', true);
    });
  }

  updateActiveState(): void {
    const url = this.router.url;
    this.isDirectoryActive = url.startsWith('/profile/directory') && !url.includes('/profile/directory/appointment');
  }

  toggleJobcornerMenuProfessional() {
    this.isJobcornermenuProf = !this.isJobcornermenuProf;
    if (this.isJobcornermenuProf) {
      this.router.navigate(['/profile/directory/add-job-profile', 'job']);
    }
  }
  toggleJobsDropdown() {
    this.isJobsDropdownOpen = !this.isJobsDropdownOpen;
    if (this.isJobsDropdownOpen) {
      this.router.navigate(['/profile/applied-job-listing']);
    }
  }

  toggleJobsDropdownClose() {
    this.isJObseekmenu = false;
    this.isBannerMenu = false;
    this.isTalentmenu = false;
    this.isJobcornermenu = false;
    this.isJobsDropdownOpen = false;
    this.isJobcornermenuProf = false;
    this.isSubMenuOpen = false;
    this.isDirectoryMenu = false;
    this.isSupportMenu = false;

  }

  toggleCatalogueMenu() {
    this.isCatalogueMenu = !this.isCatalogueMenu;
    if (this.isCatalogueMenu) {
      this.router.navigate(['/profile/catalogues/listing'])
    }
    // Optionally close other menus here
    this.isBannerMenu = false;
    this.isJobcornermenu = false;
    this.isSubMenuOpen = false;
    this.isSupportMenu = false;
    this.isUsedSuppliesMenu = false;
    this.isLearningHubMenu = false
    this.isSuppliesMenu = false;

  }

  toggleLearingHubMenu() {
    this.isLearningHubMenu = !this.isLearningHubMenu;
    if (this.isLearningHubMenu) {

      this.router.navigate(['/profile/course-listing']);
    }
    // Optionally close other menus here
    this.isBannerMenu = false;
    this.isJobcornermenu = false;
    this.isSubMenuOpen = false;
    this.isSupportMenu = false;
    this.isUsedSuppliesMenu = false;
    this.isCatalogueMenu = false;
    this.isSuppliesMenu = false;

  }



  toggleSuppliesMenu() {
    this.isSuppliesMenu = !this.isSuppliesMenu;
    if (this.isSuppliesMenu) {
      this.router.navigate(['/profile/supplies/list']);
    }
    // Optionally close other menus
    this.isCatalogueMenu = false;
    this.isBannerMenu = false;
    this.isJobcornermenu = false;
    this.isSubMenuOpen = false;
    this.isSupportMenu = false;
    this.isUsedSuppliesMenu = false;
    this.isLearningHubMenu = false

  }

  toggleUsedSuppliesMenu() {
    this.isUsedSuppliesMenu = !this.isUsedSuppliesMenu;
    if (this.isUsedSuppliesMenu) {
      this.router.navigate(['/profile/pre-owned-supplies/list']);
    }
    // Optionally close other menus
    this.isSuppliesMenu = false;
    this.isCatalogueMenu = false;
    this.isDirectoryMenu = false;
    this.isBannerMenu = false;
    this.isJobcornermenu = false;
    this.isMiscMenu = false;
    this.isSupportMenu = false;
    this.isSubMenuOpen = false;
  }

  toggleDirectoryMenu() {
    this.isDirectoryMenu = !this.isDirectoryMenu;
    if (this.isDirectoryMenu) {
      const path = this.loginData?.type === 'ADMIN'
        ? '/profile/directory/dir-listing'
        : '/profile/directory-categories';
      this.router.navigate([path]);
    }
    // Optionally close other menus
    this.isSuppliesMenu = false;
    this.isCatalogueMenu = false;
    this.isBannerMenu = false;
    this.isJobcornermenu = false;
    this.isSubMenuOpen = false;
    this.isSupportMenu = false;
    this.isUsedSuppliesMenu = false;

  }


  toggleSupportMenu() {
    this.isSupportMenu = !this.isSupportMenu;
    if (this.isSupportMenu) {
      this.router.navigate(['/profile/support-management/support']);
    }
    // Optionally close other menus:
    this.isMiscMenu = false;
    this.isSuppliesMenu = false;
    this.isCatalogueMenu = false;
    this.isDirectoryMenu = false;
    this.isJobcornermenu = false;
    this.isSubMenuOpen = false;
    this.isUsedSuppliesMenu = false;

  }

  toggleMiscMenu() {
    this.isMiscMenu = !this.isMiscMenu;
    if (this.isMiscMenu) {
      this.router.navigate(['/profile/states/list']);
    }
    // Optionally close other menus
    this.isSuppliesMenu = false;
    this.isCatalogueMenu = false;
    this.isBannerMenu = false;
    this.isJobcornermenu = false;
    this.isDirectoryMenu = false;
    this.isSubMenuOpen = false;
    this.isSupportMenu = false;
    this.isUsedSuppliesMenu = false;
  }

  bannerList: any;
  categoryList: any;
  filteredBannerList: any[] = [];
  leftNavBannerData: any[] = [];
  leftNavTimer: number = 1000;

  // BANNER ADVERTISEMNT

  getFilteredBanners(): void {
    const filters = {
      status: 'APPROVED',
      category_names: ['All Left Nav Medium Banners'],
      banner_location: [
        'Web Left Nav News Feed'
      ],
    };

    this.bannersInfoTabService.getFilteredBannersData(filters).subscribe({
      next: (data) => {
        this.bannerList = data;
        this.filterBannersByCategory();
      },
    });
  }


  getBannersCategory() {

    this.bannersInfoTabService.getBannersCategoryDatas().subscribe(data => {
      this.categoryList = data;

      const FindLeftNavTimer = data.find(category =>
        category?.name === 'All Left Nav Medium Banners'
      )?.timer

      this.updateLeftNavTimer(FindLeftNavTimer);
      // After categories loaded, filter
    });
  }

  filterBannersByCategory() {

    if (!this.bannerList) return;

    // Filter LEftNav Banner
    const today = new Date().toISOString().split("T")[0] + "T00:00:00+00:00";

    const FilterLeftNavBanner = this.bannerList.filter(
      banner =>
        banner?.category_name === 'All Left Nav Medium Banners' && banner.schedule_date <= today
    );

    // Choose Admin or non-Admin banners based on existence
    const isAdminExistLeft = FilterLeftNavBanner.some(b => b.company_name === 'ADMIN');

    const FilterLeftNavBannerData = FilterLeftNavBanner.filter(banner =>
      isAdminExistLeft ? banner.company_name === 'ADMIN' : banner.company_name !== 'ADMIN'
    );


    this.leftNavBannerData = [];
    FilterLeftNavBannerData.forEach(banner => {
      banner.image?.forEach(img => {
        this.leftNavBannerData.push({
          img,
          id: banner.id,
          url: banner.url,
          category_name: banner.category_name,
          views: banner.views,
          banner_name: banner.banner_name

        });
      });

    });

  }

  updateLeftNavTimer(newDelay: number): void {
    this.leftNavTimer = Number(newDelay) * 1000;

    this.leftNavBNSwiperConfig = {
      ...this.leftNavBNSwiperConfig,
      autoplay: {
        delay: this.leftNavTimer,
        disableOnInteraction: false,
      },
    };
  }

  public leftNavBNSwiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: this.leftNavTimer,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: true,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: true,

    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  }


  private rightNavBannerSlides() {
    this.observeBanners(
      this.LeftNavBNSlideRefs,
      this.leftNavBannerData,
      this.leftNavViewedBNIds,
      this.leftNavBNObservers,
      'leftNav'
    );
  }

  // common view 
  private observeBanners(
    slideRefs: QueryList<ElementRef>,
    banners: any[],
    viewedIds: Set<number>,
    observersArray: IntersectionObserver[],
    type: 'leftNav'
  ) {
    observersArray.forEach(observer => observer.disconnect());
    observersArray.length = 0;

    if (!slideRefs) return;

    slideRefs.forEach((slideRef: ElementRef, index: number) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const banner = banners[index];

            if (banner && !viewedIds.has(banner.id)) {
              banner.views = (banner.views || 0) + 1;
              viewedIds.add(banner.id);
              const viewscount = { views: banner.views };

              this.bannersInfoTabService.updateBanner(banner.id, viewscount).subscribe();
            }
          }
        });
      }, { threshold: 0.5 });

      observer.observe(slideRef.nativeElement);
      observersArray.push(observer);
    });
  }

  handleAction(action: string): void {

    this.dropdownStates[action] = !this.dropdownStates[action];

  }


  isLinkActive(routePath: string): boolean {
    // Option 1: Exact match (like `exact: true` in routerLinkActive)
    // return this.router.url === routePath;

    // Option 2: Partial match (parent stays active for child routes)
    if (
      this.router.url === '/profile/directory/add-job-profile/job' ||
      this.router.url.startsWith('/profile/directory/job-profile-list/edit')
    ) {
      return routePath === '/profile/directory/add-job-profile/job';
    }

    return this.router.url.startsWith(routePath);
  }

  handleMenuClick(item: MenuItem): void {
    const modules = this.loginData?.subscription_permissions?.modules;
    if (!this.loginDetails.payment_completed) {
      this.paymentModalService.openUpdateCardModalFromPlans(this.loginDetails);
    }
    const allowAll = !modules || modules.length === 0;
    const hasPermission =
      allowAll ||
      !item.requiredPermission ||
      modules.some(m => m.name === item.requiredPermission && m.permission);

    if (hasPermission) {
      this.router.navigate([item.route]);
    } else {
      if (item.requiredPermission === "directory_minimal_permission") {
        item.requiredPermission = "directory_full_access_permission";
        const hasPermissionFull =
          allowAll ||
          !item.requiredPermission ||
          modules.some(m => m.name === item.requiredPermission && m.permission);
        if (hasPermissionFull) {
          this.router.navigate([item.route]);
        } else {
          this.showAccessDenied('You do not have permission to access this feature.', this.loginData?.type);
        }
      } else {
        this.showAccessDenied('You do not have permission to access this feature.', this.loginData?.type);
      }
    }
  }

  // private openUpdateCardModalFromPlans(): void {
  //   this.subscriptionPlansService.getSubPlanById(this.loginDetails.plan_id?this.loginDetails.plan_id:this.loginDetails.subscription_id).subscribe(data => {
  //     this.subPlanDetails = data;
  //     if (this.subPlanDetails && this.subPlanDetails.monthy_price > 0) {
  //       this.userPrice = localStorage.getItem('selPrice');
  //       this.priceEx = localStorage.getItem('disValue');

  //       this._dialog.open(SignupPlanPaymentsComponent, {
  //         width: '30%',
  //         panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
  //         disableClose: true,
  //         data: {
  //           leadId: this.loginDetails.id,
  //           planDetails: this.subPlanDetails,
  //           type: "addcard"
  //         }
  //       });
  //     } else {
  //       console.log("Free plan detected → no popup opened.");
  //     }
  //   });
  //   // const currentPlan = this.allPlans.find(p => p.id === this.loginDetails.subscription_id);
  //   // console.log("currentPlan", currentPlan)
  // }

  private showAccessDenied(message: string, userType?: string): void {
    this._dialog.open(PermissionDeniedModalComponent, {
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true,
      width: '30%',
      data: {
        message: message,
        showContactAdmin: true,
        userType: userType
      }
    });
  }
  isDropdownOpen(action: string): boolean {
    return this.dropdownStates[action];
  }
  filterMenuItems(items: MenuItem[], permissionSet: Set<string>, showAll: boolean): MenuItem[] {
    return items
      .filter(item =>
        showAll || !item.requiredPermission || permissionSet.has(item.requiredPermission)
      )
      .map(item => ({
        ...item,
        children: item.children
          ? this.filterMenuItems(item.children, permissionSet, showAll)
          : undefined
      }))
      .filter(item => !item.children || item.children.length > 0);
  }

  // For module permissions
  // hasModulePermission(moduleName: string): boolean {
  //   return this.permissionService.hasModulePermissionOnly(moduleName);
  // }

  // handleModuleUnauthorized(event: Event, moduleName: string) {
  //   this.permissionService.handleModuleUnauthorizedClickOnly(event, moduleName);
  // }


  openJoinRequest() {
    this.router.navigate(['/profile/join-request']);
    this.toggleJobsDropdownClose();
  }

  loadProfessionalOrPracticeCommunities(): void {
    this.profileService.getJoinedCommunities(this.loginDetails.id)
      .subscribe((communities: CommunityMember[]) => {
        this.joinedCommunities = communities.filter(c => c.status === 'APPROVED');
        // Pick correct menu type dynamically
        const isPractice = this.loginDetails.type === 'PRACTICE';
        const menuItems = isPractice ? this.practiceMenuItems : this.menuItems;
        // Find News Feed menu item
        const newsfeedMenu = menuItems.find(item => item.label === 'News Feeds');
        if (!newsfeedMenu) return;
        if (this.joinedCommunities.length > 0) {
          // User is in one or more communities
          newsfeedMenu.route = null; // disable parent route
          newsfeedMenu.children = [
            { label: 'News Feed', route: '/profile/my-dashboard', class: 'noIconMenu communityChild' },
            ...this.joinedCommunities.map(c => ({
              label: c.community_name, route: `/profile/community-feed/${c.community_id}`, class: 'noIconMenu communityChild'
            }))
          ];
          // Open dropdown by default
          this.dropdownStates[newsfeedMenu.action || 'newsfeed'] = true;
        } else {
          // No communities → default no childre
          newsfeedMenu.children = undefined;
        }
        // Update filtered menu items
        this.filteredMenuItems = [...menuItems];
      });
  }

}
